import Button from "../Input/Button";
import PageSection from "../Layout/PageSection";
import { useFormik } from "formik";
import FormField from "../Input/FormField";
import axios from "axios";
import { API_URL } from "../../data/constants";
import Context from "../../../context";
import { useContext } from "react";

export default function ChangePassword() {
  const { contextState, setContextState } = useContext(Context);
  
  function validate(values) {
    const errors = {};

    if (!values.currentPassword) errors.currentPassword = "Required";

    if (!values.newPassword1) errors.newPassword1 = "Required";
    else if (values.newPassword1.length < 8)
      errors.newPassword1 = "Minimum 8 characters";

    if (!values.newPassword2) errors.newPassword2 = "Required";
    else if (values.newPassword2 !== values.newPassword1)
      errors.newPassword2 = "New Password must match";
    return errors;
  }

  const changePasswordForm = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword1: "",
      newPassword2: "",
    },
    validate,
    onSubmit: (values) => {
      axios
        .post(API_URL + "/Users/ResetPassword", {
          userName: localStorage.getItem("username"),
          token: localStorage.getItem("accessToken"),
          password: values.newPassword1,
          confirmPassword: values.newPassword2,
        })
        .then((res) => {
          let data = {
            type: "message",
            title: res.data.title,
            content: res.data.message,
          };
          setContextState({ ...contextState, modal: data });
          })
        .catch((err) => {
          console.error(err);
        });
    },
  });

  return (
    <>
      <h1 className="page-header-text">Change Password</h1>
      <form onSubmit={changePasswordForm.handleSubmit}>
        <PageSection isForm={true}>
          <FormField
            field="currentPassword"
            type="password"
            name="Current Password*"
            form={changePasswordForm}
          />
          <FormField
            field="newPassword1"
            type="password"
            name="New Password*"
            form={changePasswordForm}
          />
          <FormField
            field="newPassword2"
            type="password"
            name="Re-Enter New Password*"
            form={changePasswordForm}
          />
        </PageSection>
        <Button
          className="btn btn--green btn--bordered"
          type="submit"
          text="Update Password"
        />
      </form>
    </>
  );
}
